import { BaseButton } from "../../../../../../../components/Button/BaseButton.tsx";
import { ColorPicker } from "../../../../../../../components/ColorPicker/ColorPicker.tsx";
import type { RgbaColor } from "../../../../../../../types.ts";
import {
  hexToRgba,
  hexToRgbaString,
} from "../../../../../../../utils/colors.ts";
import { useWorkspaceColors } from "../../../../../../hooks/useWorkspaceColors.ts";

export const DesignerColorPicker = ({
  color,
  onColorChange,
}: {
  color: RgbaColor;
  onColorChange: (color: RgbaColor) => void;
}) => {
  const workspaceColors = useWorkspaceColors();

  return (
    <div className="flex-col w-[270px] p-200 gap-200">
      {workspaceColors.length > 0 && (
        <div className="flex-col gap-200 p-200">
          <div className="label-md-semibold">Brand colors</div>
          <div className="flex-row items-center gap-200 flex-wrap">
            {workspaceColors.map((brandColor) => (
              <BaseButton
                key={brandColor.uuid}
                className="w-1000 h-1000 rounded-full border"
                style={{
                  backgroundColor: hexToRgbaString(brandColor.color),
                }}
                onClick={() => onColorChange(hexToRgba(brandColor.color))}
              />
            ))}
          </div>
        </div>
      )}
      <ColorPicker initialColor={color} onChange={onColorChange} />
    </div>
  );
};
